<template>
    <div style="width: 400px; margin-left: auto; margin-right: auto;">
        <b-field v-for="acesso in veiculosFormat" :key="acesso.id">
            <b-message
                :type="(acesso.status == 'ATIVO')? 'is-success': 'is-danger'" 
                aria-close-label="Close message"
                has-icon
            >
                <b>Placa: </b>{{ acesso.veiculo.placa }}
                <br> 
                <b>Estado: </b>{{ acesso.status }}
                <br>
                <b>Area de Acesso: </b><span v-if="acesso.areaPrimaria == true">ÁREA PRIMÁRIA</span ><span v-else>ÁREA SECUNDÁRIA</span >
                <br>
            </b-message>
        </b-field>
        <b-field v-show="veiculosFormat.length == 0 && PlacaVeiculo.length > 0">
            <b-message 
                type="is-danger" 
                aria-close-label="Close message"
                has-icon>
                <b>Placa:</b> {{ PlacaVeiculo }} <br>
                <b>NÃO ENCONTRADO!</b>  
            </b-message>            
        </b-field>        
    </div>
</template>
<script>    
import { defineComponent } from 'vue'
import AcessosService from '@/services/AcessosService'

export default defineComponent({
name: "MensagemPlaca",
data(){
    return {
        acessos: [],
        PlacaVeiculo: ''
    }
},
mounted() {
    this.resultPlaca()
    this.PlacaVeiculo =  (this.$route.query.placa !== undefined)? this.$route.query.placa:'' 
},
methods: {
        
    resultPlaca(){
        AcessosService.getAcessosVeiculosByPlaca(this.placa).then((response) =>{
            this.acessos = response.data.content;
        })
    }, 

    formatQueryUrl(params) {
        let query = ""
        Object.keys(params).forEach(key => {

            if (key && key != "page") {
            query += `&${key}=${params[key]}`
            }

        });
        return query
    }
},
computed: {          
    placa() {
        return this.formatQueryUrl(this.$route.query);
    }, 

    veiculosFormat() {
        return this.acessos.filter((acesso) => {
            if(acesso.veiculo.placa ==  this.PlacaVeiculo){
                return {
                    "id": acesso.veiculo.id,
                    "placa": acesso.veiculo.placa,
                    "marca": acesso.veiculo.marca,
                    "modelo": acesso.veiculo.modelo,
                    "ano": acesso.veiculo.anoFabricacao,
                    "status": acesso.veiculo.status,
                    "usuario": acesso.veiculo.usuario,
                    "area": acesso.veiculo.area
                } 
            }
        })
    },

}

})
</script>